import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
export function OpeningHook() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="bg-[#0f1b2d] py-16 md:py-24 px-4" data-id="element-102">
      <div className="max-w-3xl mx-auto" data-id="element-103">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} className="text-center" data-id="element-104">
          <p className="text-lg md:text-xl text-gray-300 leading-relaxed mb-8" data-id="element-105">
            Estás en medio de un pasillo, en la cocina del restaurante, o frente
            a la computadora, y sientes que el aire se acaba. El corazón te late
            en la garganta y un sudor frío empieza a bajar por tu espalda. Tu
            primer pensamiento no es "tengo estrés". Tu primer pensamiento es:
          </p>

          <motion.blockquote initial={{
          opacity: 0,
          scale: 0.95
        }} animate={isInView ? {
          opacity: 1,
          scale: 1
        } : {}} transition={{
          duration: 0.8,
          delay: 0.3
        }} className="relative" data-id="element-106">
            <div className="absolute -left-4 top-0 text-6xl text-[#6aacb8] opacity-30 font-serif" data-id="element-107">
              "
            </div>
            <p className="text-2xl md:text-3xl lg:text-4xl font-bold text-white italic leading-tight px-8" data-id="element-108">
              Por favor, que nadie se dé cuenta... si colapso aquí, voy a perder
              mi trabajo
            </p>
            <div className="absolute -right-4 bottom-0 text-6xl text-[#6aacb8] opacity-30 font-serif" data-id="element-109">
              "
            </div>
          </motion.blockquote>
        </motion.div>
      </div>
    </section>;
}